import styled from "styled-components";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import CustomIcon from "../Global/Icons/CustomIcon";
import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import Spinner from "../Global/Atomics/Spinner";
import { useState } from "react";
import { useEffect } from "react";
import { Text } from "../Global/Atomics/Text";
import Theme from '../../styles/Theme/Theme';
import { io } from "socket.io-client";
import { websocketPort } from "../../server/websocketPort";

const GridColumn = styled.div`
    background-color: 'green';
    display: 'grid';
    grid-column: ${props => (props.gridColumn ? props.gridColumn : null)};
    grid-row: ${props => (props.gridRow ? props.gridRow : null)};
`;

const socket = io(websocketPort);
export const OperationStatusWidget = () => {
    const { data: operationStatusData, isLoading, refetch: refetchOperationStatus } = useFetch(query.path.operationStatus, 'getOperationStatus');
    const [operatioStatusData, setOperationsStatusData] = useState(null);

    useEffect(() => {
        setOperationsStatusData(operationStatusData?.data);
    }, [isLoading, operationStatusData?.data])

    useEffect(() => {
        socket.on("incidents", (text) => {
            refetchOperationStatus();
        });
    }, [])

    return (
        <>
            {operatioStatusData && operatioStatusData.length ?
                <WidgetCard display='grid' padding={Theme.spacing.videowall.md} margin={Theme.spacing.videowall.xxs} style={{ gridTemplateColumns: `1.5fr repeat(${operatioStatusData.length}, 1fr)`, gridTemplateRows: '0.8fr 0.5fr 0.5fr 0.5fr', gridAutFlow: 'column' }}>
                    <FirstColumn />
                    {operatioStatusData.map((val, key) => {
                        return (<NextColumn key={key} props={val} gridColumn={key + 2}
                            borderTopRightRadius={operatioStatusData.length - 1 === key ? '12px' : null}
                            borderBottomRightRadius={operatioStatusData.length - 1 === key ? '12px' : null} />)
                    })}
                </WidgetCard>
                : <div style={{ height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}><Spinner stroke="green" /></div>
            }
        </>
    )
}

const FirstColumn = () => {
    return (
        <>
            <GridColumn gridColumn='1' gridRow='1 / 2' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderBottom: '1px ridge gray' }}>
                <div style={{ display: 'flex', alignItems: 'center', alignSelf: 'flex-start' }}>
                    <CustomIcon icon={'Clipboard'} iconSize='lg' color={Theme.color['teal-4']} />
                    <Text color={Theme.color['coolgray-12']} marginLeft='0.4vw' fontSize='text_xl' fontWeight={Theme.typography.weight.medium}>Operation Status</Text>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <Text color={Theme.color['coolgray-12']} margin='0' fontSize='text_lg' fontWeight={Theme.typography.weight.medium} marginLeft='20px'>Incidents</Text>
                    <Text color={Theme.color['coolgray-10']} margin='0' fontSize='text_lg'>Critical & High</Text>
                </div>
            </GridColumn>
            <GridColumn gridColumn='1' gridRow='2 / 3' style={{ display: 'flex', placeItems: 'center', justifyContent: 'flex-end' }}>
                <Text color={Theme.color['coolgray-10']} margin='0' fontSize='text_lg'>MRT | Availability</Text>
            </GridColumn>
            <GridColumn gridColumn='1' gridRow='3 / 4' style={{ display: 'flex', placeItems: 'center', justifyContent: 'space-between' }}>
                <Text color={Theme.color['coolgray-12']} margin='0' fontSize='text_lg' fontWeight={Theme.typography.weight.medium} marginLeft='20px'>Service Quality</Text>
                <div style={{ backgroundColor: '#F2F6F7', height: '-webkit-fill-available', display: 'flex', alignItems: 'center', paddingLeft: '20px', borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px' }}><Text color='#0076A8' margin='0' fontSize='text_lg' fontWeight={Theme.typography.weight.bold}>Current</Text></div>
            </GridColumn>
            <GridColumn gridColumn='1' gridRow='4 / 5' style={{ display: 'flex', placeItems: 'center', justifyContent: 'flex-end' }}>
                <Text color={Theme.color['coolgray-12']} margin='0' fontSize='text_lg'>Next Hour</Text>
            </GridColumn>
        </>
    )
};

const NextColumn = (props) => {
    return (
        <>
            <GridColumn gridColumn={props.gridColumn} gridRow='1 / 2' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px ridge gray' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5vh' }}>
                    <CustomIcon icon={props?.props?.icon} iconSize='xxl' BgColor={Theme.color['blue-4']} />
                </div>
                <Text color={Theme.color['black-1']} marginBottom='10px' fontSize='text_xl' fontWeight={Theme.typography.weight.medium}>{props?.props?.value}</Text>
            </GridColumn>
            <GridColumn gridColumn={props.gridColumn} gridRow='2 / 3' style={{ display: 'flex', placeItems: 'center', justifyContent: 'center' }}>
                <Text color={Theme.color['coolgray-10']} margin='0' fontSize='text_lg'>{props?.props?.mrt}</Text><Text color={Theme.color['coolgray-12']} margin='0' fontSize='text_lg'>&nbsp;| {props?.props?.availability}%</Text>
            </GridColumn>
            <GridColumn gridColumn={props.gridColumn} gridRow='3 / 4' style={{ display: 'flex', placeItems: 'center', justifyContent: 'center', backgroundColor: '#F2F6F7', padding: '10px', borderTopRightRadius: props.borderTopRightRadius, borderBottomRightRadius: props.borderBottomRightRadius }}>
                <div style={{ marginRight: '10px', display: 'flex', visibility: props?.props?.current?.tendency === 0 ? 'hidden' : null }}>
                    <CustomIcon style={{ marginRight: '10px' }} iconSize='md'
                        icon={checkTendency(props?.props?.current?.tendency)}
                        color={props?.props?.current?.tendency === 1 ? Theme.color['error-4'] : props?.props?.current?.tendency === 2 ? Theme.color['success-4'] : null}
                        BgColor={props?.props?.current?.tendency === 1 ? Theme.color['error-1'] : props?.props?.current?.tendency === 2 ? Theme.color['success-1'] : null} />
                </div>
                <div style={{ display: 'flex', visibility: props?.props?.current?.state === 0 ? 'hidden' : null }}>
                    <CustomIcon icon={'QualityCircle'} color={checkState(props?.props?.current?.state)} iconSize='lg' />
                </div>
            </GridColumn>
            <GridColumn gridColumn={props.gridColumn} gridRow='4 / 5' style={{ display: 'flex', placeItems: 'center', justifyContent: 'center' }}>
                <div style={{ marginRight: '10px', display: 'flex', visibility: props?.props?.forecast?.tendency === 0 ? 'hidden' : null }}>
                    <CustomIcon style={{ marginRight: '10px' }} iconSize='lg'
                        icon={checkTendency(props?.props?.forecast?.tendency)}
                        color={props?.props?.forecast?.tendency === 1 ? Theme.color['error-4'] : props?.props?.forecast?.tendency === 2 ? Theme.color['success-4'] : null}
                        BgColor={props?.props?.forecast?.tendency === 1 ? Theme.color['error-1'] : props?.props?.forecast?.tendency === 2 ? Theme.color['success-1'] : null} />
                </div>
                <div style={{ display: 'flex', visibility: props?.props?.forecast?.state === 0 ? 'hidden' : null }}>
                    <CustomIcon icon={'QualityCircle'} color={checkState(props?.props?.forecast?.state)} iconSize='lg' />
                </div>
            </GridColumn>
        </>
    )
}

function checkState(value) {
    switch (value) {
        case 1:
            return Theme.color['critical-base']
        case 2:
            return Theme.color['high-base']
        case 3:
            return Theme.color['medium-base']
        case 4:
            return Theme.color['low-base']
        case 5:
            return Theme.color['coolgray-6']
        default:
            return Theme.color['white'];
    }
}

function checkTendency(value) {
    if (value === 1) {
        return 'QualityBad'
    } else {
        return 'QualityGood'
    }
}